import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

const Cart = (props) => (
  <SvgIcon viewBox="0 3 24 19" {...props}>
    <polyline fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
      1,3.816 5.246,3.816 9.105,15.395 19.912,15.395 23,6.518 6.404,6.518 "/>
    <circle fill="#FFFFFF" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" cx="10.456" cy="19.677" r="1.351"/>
    <circle fill="#FFFFFF" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" cx="18.561" cy="19.833" r="1.351"/>
  </SvgIcon>
);

export default Cart;



// WEBPACK FOOTER //
// ./src/icons/Cart.jsx